export default __webpack_public_path__ + "media/images/ui-bg_glass_50_3baae3_1x400-69278a310d0cc8d2905c08a79e3cb6a9.png";